import React from 'react'

import { Combobox } from '@headlessui/react'
import { clsx } from 'clsx'

import { Hotkey } from '@tribeplatform/react-ui-kit/Hotkey'
import {
  Icon,
  SvgIcon,
  type SvgIconName,
} from '@tribeplatform/react-ui-kit/Icon'

import { type CommandBarActionType } from './types.js'

interface Props {
  action: CommandBarActionType
  hideHotkey?: boolean
}

export const CommandBarAction = ({ action, hideHotkey }: Props) => {
  const icon =
    typeof action?.icon === 'string' ? (
      <SvgIcon
        name={(action?.icon as SvgIconName) || 'arrow-right'}
        className="flex-none"
      />
    ) : (
      React.isValidElement(action?.icon) && action?.icon
    )

  return (
    <Combobox.Option
      key={action.name}
      value={action}
      className={({ active }) =>
        clsx(
          'flex cursor-default select-none items-center px-4 py-3',
          active && 'bg-surface-subdued',
        )
      }
    >
      <Icon size="lg" className="flex-none">
        {icon}
      </Icon>
      <span className="ms-3 flex-auto truncate">{action.name}</span>
      {!hideHotkey && action?.hotkey && (
        <Hotkey className="px-2">{action?.hotkey}</Hotkey>
      )}
    </Combobox.Option>
  )
}
